import concat from 'lodash/concat';

import Admin from '../../../views/Admin/index.vue';
import pedingForOrder from './pendingForOder';

import complements from './complements';
import settings from './settings';

export default [
  {
    path: '/admin',
    name: 'Admin',
    component: Admin,
    meta: { auth: true },
    redirect: { name: 'Home' },
    children: concat(
      pedingForOrder,
      complements,
      settings,
    ),
  },
];
